$(function() {
  const submitComment = function(e) {
    e.preventDefault();
    const form = $(this).closest("form");
    const entityId = form.find('input[name="entity_id"]').val();

    $.ajax({
      type: form.attr("method"),
      url: form.attr("action"),
      data: form.serialize(),
      success: function(response) {
        const replyToId = form.find('input[name="reply_to"]').val();
        // Check if this is an inline comments form (feed view)
        const inlineContainer = form.closest('.inline-comments');
        if (inlineContainer.length) {
          // Dispatch event for Alpine component to handle the new comment.
          // The widget listens on the post, while a reply form names the attached photo,
          // so the container owns the id here. The delete handler reads the same one.
          window.dispatchEvent(new CustomEvent('comment-added', {
            detail: {
              entityId: inlineContainer.attr('data-entity-id'),
              html: response,
              replyToId: replyToId
            }
          }));
        } else {
          // A reply belongs under its parent. comments/comment-item.twig carries the indent
          // rail, so the response appends unwrapped.
          const replyContainer = replyToId
            ? form.closest(".comment").find('[data-replies-for="' + replyToId + '"]')
            : $();
          let inserted = replyContainer.length > 0;
          if (inserted) {
            replyContainer.append(response);
            const parentComment = replyContainer.closest('.comment');
            const replyCount = parseInt(parentComment.attr('data-reply-count'), 10) || 0;
            parentComment.attr('data-reply-count', replyCount + 1);
          } else {
            // Reply forms are nested inside .comment which is inside .comment-list.
            // Main forms are siblings of .comment-list via .comment-form-section.
            let commentList = form.closest(".comment-list");
            if (!commentList.length) {
              commentList = form.closest(".comments, .comment-form-section").parent().find(".comment-list");
            }
            inserted = commentList.length > 0;
            commentList.removeClass("hidden").prepend(response);
          }
          // The photo viewer's counter reads this event, and must not count a node
          // that no container took.
          if (inserted) {
            window.dispatchEvent(new CustomEvent("comment-added", {
              detail: { entityId: entityId, html: response, replyToId: replyToId }
            }));
          }
        }
        form.find(".comment-input").val("");
        form.find(".comment-submit-button").addClass("hidden");
        form.find(".error-message").addClass("hidden");

        // Hide reply form after submission
        if (form.closest(".comment").length) {
          form.addClass("hidden");
        }

        // Initialize icons in new comment
        if (window.LucideIcons) {
          window.LucideIcons.initialize(document.body);
        }
      },
      error: function(response) {
        // The phone gate names the verify page, and the user has no other way
        // forward from this form. Navigating leaves the error span alone.
        const gate = window.PhoneGateRefusal;
        if (gate && gate.followWeb(gate.refusalBody(response))) return;

        form.find(".error-message").removeClass("hidden").text(response.responseText ?? "An error occurred");
        form.find(".comment-input").focus();
      }
    });
  };

  // Use event delegation for dynamically loaded comment forms
  $(document).on("input", ".comment-input", function() {
    const submitButton = $(this).closest("form").find(".comment-submit-button");
    if ($(this).val().length > 0) {
      submitButton.removeClass("hidden");
    } else {
      submitButton.addClass("hidden");
    }
  });

  $(document).on("submit", ".comment-form", submitComment);

  $(document).on("click", ".comment-submit-button", function() {
    $(this).closest("form").submit();
  });

  $(document).on("click", ".comment-reply-button", function(e) {
    e.preventDefault();
    const comment = $(this).closest(".comment");
    const replyForm = comment.find(".comment-form");
    replyForm.removeClass("hidden");
    replyForm.find(".comment-input").focus();
  });

  // Use document.on() to bind events to elements that are not yet in
  // the DOM since language select items are added dynamically
  $(document).on("click", ".comment-delete-button", function(e) {
    e.preventDefault();
    const comment = $(this).closest(".comment");
    const deleteUrl = $(this).data("url");

    ConfirmModal.show({
      message: window.tOr('common.comment_delete_confirm', 'Are you sure you want to permanently delete this comment?'),
      type: 'danger',
      onConfirm: async function() {
        $.ajax({
          type: "DELETE",
          url: deleteUrl,
          headers: {
            "X-AUTH-TOKEN": await window.getApiToken()
          },
          success: function(response) {
            const repliesContainer = comment.parent('[data-replies-for]');
            const parentComment = repliesContainer.closest('.comment');
            // Read the ids with attr() (not data()) so large ids stay strings, and before
            // removal, since a detached node has none. The widget listens on the post while
            // the comment names the attached photo, so the container wins. Photo pages have none.
            const entityId = comment.closest(".inline-comments").attr("data-entity-id")
              || comment.attr("data-entity-id");
            // Use the stored total when the bounded reply list omits rows.
            const replyCount = Math.max(
              comment.find(".comment").length,
              parseInt(comment.attr("data-reply-count"), 10) || 0
            );
            let visibleDescendantCount = 0;
            if (parentComment.length) {
              const descendantParentIds = new Set([comment.attr('data-comment-id')]);
              let foundDescendant = true;
              while (foundDescendant && visibleDescendantCount < 25) {
                foundDescendant = false;
                repliesContainer.children('.comment').each(function() {
                  const reply = $(this);
                  if (
                    visibleDescendantCount < 25
                    && descendantParentIds.has(reply.attr('data-reply-to-id'))
                  ) {
                    descendantParentIds.add(reply.attr('data-comment-id'));
                    reply.remove();
                    ++visibleDescendantCount;
                    foundDescendant = true;
                  }
                });
              }
            }
            if (parentComment.length) {
              const parentReplyCount = parseInt(parentComment.attr("data-reply-count"), 10) || 0;
              parentComment.attr(
                "data-reply-count",
                Math.max(0, parentReplyCount - 1)
              );
            }
            comment.remove();
            if (entityId) {
              const serverDeletedCount = parseInt(response && (response.deleted_visible_count ?? response.deleted_count), 10);
              window.dispatchEvent(new CustomEvent("comment-deleted", {
                detail: {
                  entityId: entityId,
                  count: Number.isNaN(serverDeletedCount)
                    ? 1 + Math.min(Math.max(replyCount, visibleDescendantCount), 25)
                    : serverDeletedCount
                }
              }));
            }
          },
          error: function() {
            alert(window.tOr('common.comment_delete_error', 'An error occurred while deleting the comment'));
          }
        });
      }
    });
  });
});
